import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Download, ArrowUpDown, ChevronDown, ChevronUp, Loader } from 'lucide-react';
import { FaRegFilePdf, FaRegFileWord, FaRegFileExcel } from 'react-icons/fa';
import { useLanguage } from '../context/LanguageContext';

const PdfItarNamune = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 40;

  const initialData = [
    { id: 1, name: 'मुख्यमंत्री समृद्ध पंचायत राज अभियानppt - मुख्य प्रश्नावली pdf', type: 'pdf' },
    { id: 2, name: 'फेरआकारणी पंचनामा word', type: 'word' },
    { id: 3, name: 'मुख्यमंत्री समृद्ध पंचायतराज अभियान गुणांकन excel', type: 'excel' },
    { id: 4, name: 'ध्वजारोहण- मुख्याध्यापक पत्र (26 जानेवारी)', type: 'pdf' },
    { id: 5, name: 'QR CODE- मेरी पंचायत, पंचायत निर्णय, ग्रामसंवाद ॲप', type: 'pdf' },
    { id: 6, name: 'Water budget- पाण्याचा ताळेबंद नमुना 1', type: 'excel' },
    { id: 7, name: 'Water budget - पाण्याचा ताळेबंद नमुना 3', type: 'excel' },
    { id: 8, name: 'Water budget - पाण्याचा ताळेबंद- नमुना 2', type: 'excel' },
    { id: 9, name: 'PAI LETTER pdf', type: 'pdf' },
    { id: 10, name: 'मुख्यमंत्री समृद्ध पंचायतराज अभियान- गुणांकन फॉर्म (mark form)', type: 'pdf' },
    { id: 11, name: 'ध्वजारोहण- मुख्याध्यापक पत्र (15 ऑगस्ट)', type: 'pdf' },
    { id: 12, name: 'ध्वजारोहण - मुख्याध्यापक पत्र- 1 may', type: 'pdf' },
    { id: 13, name: 'नमुना नं.12 word', type: 'word' },
    { id: 14, name: 'लोकसेवा अर्ज नोंदवही.pdf', type: 'pdf' },
    { id: 15, name: 'जयंती फलक pdf -हिंदुहृदयसम्राट बाळासाहेब ठाकरे', type: 'pdf' },
    { id: 16, name: 'जयंती फलक pdf -नेताजी सुभाषचंद्र बोस', type: 'pdf' },
    { id: 17, name: 'जयंती फलक pdf -स्वामी विवेकानंद', type: 'pdf' },
    { id: 18, name: 'जयंती फलक pdf -जिजाऊ माँ साहेब', type: 'pdf' },
    { id: 19, name: 'जयंती फलक pdf - क्रांतीज्योती सावित्रीबाई फुले', type: 'pdf' },
    { id: 20, name: 'माझी ग्रामपंचायत कॅलेंडर 2025 pdf', type: 'pdf' },
    { id: 21, name: 'namuna 1 andajpatrak अंदाजपत्रक 2025-26 excel', type: 'excel' },
    { id: 22, name: 'अंदाजपत्रक नं.नं-1 pdf', type: 'pdf' },
    { id: 23, name: 'विवाह नोंदणी मासिक अहवाल pdf', type: 'pdf' },
    { id: 24, name: 'विवाह नोंदणी मासिक अहवाल word', type: 'word' },
    { id: 25, name: 'ध्वजारोहण मुख्याध्यापक पत्र (17 सप्टेंबर)', type: 'pdf' },
    { id: 26, name: 'जमा- खर्च महिनानिहाय Tally- excel', type: 'excel' },
    { id: 27, name: 'वार्षिक प्रशासन अहवाल pdf', type: 'pdf' },
    { id: 28, name: 'वार्षिक प्रशासन अहवाल 2023-24- excel', type: 'excel' },
    { id: 29, name: 'PDI- माहिती संकलनासाठी पत्राचा नमुना pdf', type: 'pdf' },
    { id: 30, name: 'माझी ग्रामपंचायत कॅलेंडर 2024 pdf', type: 'pdf' },
    { id: 31, name: 'ध्वजारोहण निमंत्रण पत्र - 1 मे 2023', type: 'pdf' },
    { id: 32, name: 'गाव आपत्ती व्यवस्थापन आराखडा नमुना', type: 'pdf' },
    { id: 33, name: 'माझी ग्रामपंचायत calendar 2023 pdf', type: 'pdf' },
    { id: 34, name: 'GPDP 2023-24 plan Excel- locked', type: 'excel' },
    { id: 35, name: 'GPDP 2023-24 plan Excel- unlocked', type: 'excel' },
    { id: 36, name: 'संत गाडगेबाबा ग्राम स्वच्छता अभियान सन “राष्ट्रसंत तुकडोजी महाराज स्वच्छ ग्राम स्पर्धा फॉर्म', type: 'pdf' },
    { id: 37, name: 'हर तिरंगा अभियान- झेंडा फडकविण्याबाबत नियम- पोस्टर', type: 'pdf' },
    { id: 38, name: 'हर घर तिरंगा- मुख्यमंत्री पत्र', type: 'pdf' },
    { id: 39, name: 'नमुना नं.9 excel (1500 खातेदार)', type: 'excel' },
    { id: 40, name: 'नमुना नं.9 excel (1000 खातेदार)', type: 'excel' },
    { id: 41, name: 'नमुना नं.9 excel (500 खातेदार)', type: 'excel' },
    { id: 42, name: 'सदस्य बैठक भत्ता माहिती नमुना', type: 'pdf' },
    { id: 43, name: 'महापंचायतराज अभियान अहवाल (प्रपत्र 1 ते 7)', type: 'pdf' },
    { id: 44, name: 'टिप्पणी नमुना eGramSwaraj-pfms', type: 'pdf' },
    { id: 45, name: 'मेडिकल बिल', type: 'pdf' },
    { id: 46, name: 'माझी ग्रामपंचायत दिनदर्शिका (calendar) 2022', type: 'pdf' },
    { id: 47, name: 'MGNREGA- कृतीआराखडा 2022-23 प्रपत्र', type: 'word' },
    { id: 48, name: 'प्रशासकीय मान्यता नमुना- 15 वा वित्त word', type: 'word' },
    { id: 49, name: 'प्रशासकीय मान्यता नमुना', type: 'pdf' },
    { id: 50, name: 'प्रशासकीय मान्यता नमुना- 15 वा वित्त', type: 'pdf' },
    { id: 51, name: 'प्रशासकीय मान्यता नमुना word', type: 'word' },
    { id: 52, name: 'SBM-घनकचरा व सांडपाणी व्यवस्थापन- प्रपत्र 1 ते 13', type: 'pdf' },
    { id: 53, name: 'राष्ट्रसंत तुकडोजी म.स्वच्छ ग्राम स्पर्धा गुणांकन फॉर्म', type: 'pdf' },
    { id: 54, name: 'संत गाडगेबाबा ग्रामस्वच्छता-उत्कृष्ट प्रभाग गुणांकन फॉर्म', type: 'pdf' },
    { id: 55, name: 'SBM हागणदारीमुक्त अधिक (ODF Plus) पडताळणी प्रपत्रे', type: 'pdf' },
    { id: 56, name: 'लाभार्थी sample list', type: 'pdf' },
    { id: 57, name: 'जैवविविधता नोंदवही नमुना', type: 'pdf' },
    { id: 58, name: 'GPDP-प्रकल्प अहवाल', type: 'pdf' },
    { id: 59, name: 'कर आकारणी excel', type: 'excel' },
    { id: 60, name: 'थोडेसे मायबापासाठी पण जेष्ठ नागरिक सर्वेक्षण नमुना', type: 'pdf' },
    { id: 61, name: 'कर्मचारी नियुक्ती आदेश व हमीपत्र नमुना', type: 'pdf' },
    { id: 62, name: 'ग्रामीण पाणी पुरवठा योजनांच्या वीज बिलाच्या अनुषंगाने माहिती', type: 'pdf' },
    { id: 63, name: 'कोरोना उपाययोजना Booklet- word', type: 'word' },
    { id: 64, name: 'GRBook -14 वा वित्त आयोग', type: 'pdf' },
    { id: 65, name: 'GRBook- corona', type: 'pdf' },
    { id: 66, name: 'Cashbook tally excel', type: 'excel' },
    { id: 67, name: 'अभिलेख वर्गीकरण पुस्तिका-अबकड', type: 'pdf' },
    { id: 68, name: 'MGNREGA- कामे-खर्च-मनुष्यदिन-यंत्रणा pdf', type: 'pdf' },
    { id: 69, name: 'कोरोनामुक्त गाव पुरस्कार योजना- गुणांकन फॉर्म', type: 'pdf' },
    { id: 70, name: 'नमुना नं.27 (लेखापरिक्षण आक्षेप पुर्तता अहवाल)', type: 'pdf' },
    { id: 71, name: 'सरपंच/उपसरपंच/सदस्य रिक्त पद अहवाल', type: 'pdf' },
    { id: 72, name: 'रमाई आवास- चेकलिस्ट', type: 'pdf' },
    { id: 73, name: 'मासिक अहवाल नमुना', type: 'pdf' },
    { id: 74, name: 'मासिक अहवाल- जन्म मृत्यु', type: 'pdf' },
    { id: 75, name: 'मत्ता व दायित्वे विवरणपत्र', type: 'pdf' },
    { id: 76, name: 'फेरआकारणी पंचनामा', type: 'pdf' },
    { id: 77, name: 'पावती नावेची (व्हावचर) SBM', type: 'pdf' },
    { id: 78, name: 'पावती नावेची (व्हावचर)', type: 'pdf' },
    { id: 79, name: 'परतावा देयक नमुना', type: 'pdf' },
    { id: 80, name: 'पदभार यादी (charge list)', type: 'pdf' },
    { id: 81, name: 'ना हरकत नकार पत्र', type: 'pdf' },
    { id: 82, name: 'नमुना नं. 2 (सुधारित अंदाजपत्रक)', type: 'pdf' },
    { id: 83, name: 'नमुना नं.4 (पंचायतीचे मत्ता व दायित्वे)', type: 'pdf' },
    { id: 84, name: 'नमुना नं.12 (आकस्मिक खर्चाचे प्रमाणक)', type: 'pdf' },
    { id: 85, name: 'नमुना नं.12 (आकस्मिक खर्चाचे प्रमाणक) word', type: 'word' },
    { id: 86, name: 'नमुना नं 32- रक्कम परतावा आदेश', type: 'pdf' },
    { id: 87, name: 'वेतनवाढ नमुना', type: 'pdf' },
    { id: 88, name: 'नष्ट केलेल्या अभिलेखांची नोंदवही', type: 'pdf' },
    { id: 89, name: 'देणगीची नोंदवही', type: 'pdf' },
    { id: 90, name: 'टिप्पणी नमुना- मासिकसभा', type: 'pdf' },
    { id: 91, name: 'जलसेवक नामनिर्देशपत्र', type: 'pdf' },
    { id: 92, name: 'ग्रामपंचायत सदस्य माहिती नमुना', type: 'pdf' },
    { id: 93, name: 'ग्रामपंचायत (ग्रामसेवक) डायरी', type: 'pdf' },
    { id: 94, name: 'ग्रामपंचायत करआकारणी माहितीपुस्तिका', type: 'pdf' },
    { id: 95, name: 'दिव्यांग (अपंग) नोंदवही नमुना', type: 'pdf' },
    { id: 96, name: 'अनुदान नोंदवही नमुना', type: 'pdf' },
    { id: 97, name: 'अतिक्रमण नियमानुकूल- प्रपत्र अ फॉर्म', type: 'pdf' },
    { id: 98, name: 'माहिती अधिकार- त्रयस्थ पक्ष निर्णय', type: 'pdf' },
    { id: 99, name: 'माहिती अधिकार- त्रयस्थ पक्ष नोटीस', type: 'pdf' },
    { id: 100, name: 'माहितीचा अधिकार-अनेक विषय पत्र', type: 'pdf' },
    { id: 101, name: 'माहितीचा अधिकर- माहितीसोबतचे पत्र', type: 'pdf' },
    { id: 102, name: 'माहिती अधिकार- शुल्क पत्र', type: 'pdf' },
    { id: 103, name: 'ग्रा.पं.- सर्वसाधारण तपासणी नमुना', type: 'pdf' },
    { id: 104, name: 'ग्रा.पं.- सखोल तपासणी नमुना', type: 'pdf' },
    { id: 105, name: 'कोरोना प्रोत्साहन भत्ता वाटप नमुना', type: 'pdf' },
    { id: 106, name: 'मासिक दैनंदिनी word', type: 'word' },
    { id: 107, name: 'मासिक दैनंदिनी', type: 'pdf' },
    { id: 108, name: 'कोरोना उपाययोजना माहिती Booklet', type: 'pdf' },
    { id: 109, name: 'म.ग्रा.अधिनियम-कलमे मा.पु.', type: 'pdf' },
    { id: 110, name: 'ग्रामपंचायत प्रमाणपत्रे माहिती पुस्तिका', type: 'pdf' },
    { id: 111, name: 'कर्मचारी भविष्य निर्वाह निधी फॉर्म', type: 'pdf' },
    { id: 112, name: 'अपघात विमा नामनिर्देशनपत्र', type: 'pdf' },
    { id: 113, name: 'ऑपरेटरला कामाबाबत पत्र', type: 'pdf' },
    { id: 114, name: 'ताबा पावती', type: 'pdf' },
    { id: 115, name: 'PFMS vendor form', type: 'pdf' },
    { id: 116, name: 'smart ग्राम गुणांकन फॉर्म', type: 'pdf' },
    { id: 117, name: 'जन्म मृत्यु-court say', type: 'pdf' },
  ];

  const [generatingId, setGeneratingId] = useState(null);

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const filteredData = useMemo(() => {
    let sortableItems = [...initialData];

    if (searchTerm) {
      sortableItems = sortableItems.filter((item) =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.id.toString().includes(searchTerm)
      );
    }

    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableItems;
  }, [searchTerm, sortConfig]);

  // Pagination logic
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const SortIcon = ({ columnKey }) => {
    if (sortConfig.key !== columnKey) {
      return <ArrowUpDown className="w-4 h-4 text-gray-300 mx-1 inline" />;
    }
    return sortConfig.direction === 'ascending'
      ? <ChevronUp className="w-4 h-4 text-gray-500 mx-1 inline" />
      : <ChevronDown className="w-4 h-4 text-gray-500 mx-1 inline" />;
  };

  const generatePDF = async (item) => {
    if (item.id === 2 || item.id === 76) {
      navigate('/pher-aakarani-panchnama-form');
      return;
    }

    if (item.id === 4) {
      window.open('/dhvajarohan-26jan-form', '_blank');
      return;
    }

    if (item.id === 5) {
      window.open('/qr-code-app-download-form', '_blank');
      return;
    }

    if (item.id === 12) {
      window.open('/dhvajarohan-1may-form', '_blank');
      return;
    }

    setGeneratingId(item.id);
    // Simulate loading for now since actual files aren't linked yet
    setTimeout(() => {
      setGeneratingId(null);
      alert(language === 'marathi' ? `${item.name} डाउनलोड लवकरच उपलब्ध होईल!` : `${item.name} download will be available soon!`);
    }, 1000);
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col font-sans">
      <main className="flex-grow py-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Main Card Container */}
          <div className="bg-white shadow-xl rounded-lg border border-gray-200 overflow-hidden">

            {/* Header Title Bar */}
            <div className="bg-[#fff1c9] border-b border-[#e5d4a1] py-2 px-4 flex justify-between items-center gap-2">
              <h2 className="text-[#000080] text-[15px] sm:text-xl font-bold flex items-center ">
            {/* Custom dark blue multi-pointed star as in the image */}
                <svg className="w-5 h-5 mr-3 text-[#000080] fill-current" viewBox="0 0 24 24">
                  <path d="M12 2l2.4 2.4L18 3.5l1.5 3.3 3.5.9-1.2 3.2 2.2 2.6-2.2 2.6 1.2 3.2-3.5.9-1.5 3.3-3.6-1.1L12 22l-2.4-2.4L6 20.5l-1.5-3.3-3.5-.9 1.2-3.2-2.2-2.6 2.2-2.6-1.2-3.2 3.5-.9 1.5-3.3 3.6 1.1z" />
                </svg>
                {language === 'marathi' ? 'इतर नमुने' : 'Other Forms'}
          </h2>
          <button onClick={() => window.history.back()} className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-1 px-4 rounded text-sm no-print whitespace-nowrap shrink-0">
                  {language === 'marathi' ? 'मागे जा' : 'Back'}
                </button>
            </div>

            {/* Search Bar */}
            <div className="flex justify-end bg-white py-3 px-4 border-b border-gray-200">
              <div className="flex items-center">
                <label className="text-gray-600 mr-2 text-sm font-medium">Search:</label>
                <input
                  type="text"
                  className="border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:border-[#337ab7] focus:ring-1 focus:ring-[#337ab7] w-48"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1); // Reset page on search
                  }}
                />
              </div>
            </div>

            {/* Table Container for responsiveness */}
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse min-w-[700px]">
                <thead>
                  <tr className="bg-[#fdfdfd] border-b-2 border-gray-200 shadow-sm">
                    <th
                      className="py-3 px-4 border-r border-gray-100 font-bold text-[#00008b] text-sm cursor-pointer hover:bg-gray-50 transition-colors whitespace-nowrap"
                      onClick={() => handleSort('id')}
                      style={{ width: '80px' }}
                    >
                      <div className="flex items-center justify-between">
                        <span>{language === 'marathi' ? 'नं' : 'No'}</span>
                        <SortIcon columnKey="id" />
                      </div>
                    </th>
                    <th
                      className="py-3 px-4 border-r border-gray-100 font-bold text-[#00008b] text-sm cursor-pointer hover:bg-gray-50 transition-colors"
                      onClick={() => handleSort('name')}
                    >
                      <div className="flex items-center justify-between">
                        <span>{language === 'marathi' ? 'नाव' : 'Name'}</span>
                        <SortIcon columnKey="name" />
                      </div>
                    </th>
                    <th className="py-3 px-4 border-r border-gray-100 font-bold text-[#00008b] text-sm text-center w-32 cursor-pointer hover:bg-gray-50 transition-colors">
                      <div className="flex items-center justify-center space-x-1">
                        <span>{language === 'marathi' ? 'प्रकार' : 'Type'}</span>
                        <ArrowUpDown className="w-4 h-4 text-gray-300 ml-1 inline" />
                      </div>
                    </th>
                    <th className="py-3 px-4 font-bold text-[#00008b] text-sm text-center w-48 cursor-pointer hover:bg-gray-50 transition-colors">
                      <div className="flex items-center justify-center space-x-1">
                        <span>{language === 'marathi' ? 'डाऊनलोड करा' : 'Download'}</span>
                        <ArrowUpDown className="w-4 h-4 text-gray-300 ml-1 inline" />
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white">
                  {paginatedData.length > 0 ? (
                    paginatedData.map((item, index) => (
                      <tr
                        key={item.id}
                        className={`border-b border-gray-200 hover:bg-[#f8fafc] transition-colors ${index % 2 === 0 ? 'bg-[#fbfbfb]' : 'bg-white'}`}
                      >
                        <td className="py-2.5 px-4 text-sm text-[#000080] border-r border-gray-100 text-left font-medium">
                          {item.id}
                        </td>
                        <td className="py-2.5 px-4 text-sm text-[#4a729e] border-r border-gray-100">
                          {item.name}
                        </td>
                        <td className="py-2.5 px-4 text-center border-r border-gray-100">
                          {item.type === 'word' ? (
                            <FaRegFileWord className="w-5 h-5 text-[#000080] mx-auto opacity-75" />
                          ) : item.type === 'excel' ? (
                            <FaRegFileExcel className="w-5 h-5 text-[#000080] mx-auto opacity-75" />
                          ) : (
                            <FaRegFilePdf className="w-5 h-5 text-[#000080] mx-auto opacity-75" />
                          )}
                        </td>
                        <td className="py-2.5 px-4 text-center">
                          <button
                            onClick={() => generatePDF(item)}
                            disabled={generatingId === item.id}
                            className={`text-white text-xs px-3 py-1.5 rounded-sm flex items-center justify-center mx-auto space-x-1 shadow-sm transition-all flex-nowrap w-36 ${generatingId === item.id
                              ? 'bg-gray-500 cursor-not-allowed'
                              : 'bg-[#00a65a] hover:bg-[#008d4c]'
                              }`}
                          >
                            {generatingId === item.id ? (
                              <Loader className="w-3.5 h-3.5 animate-spin" />
                            ) : (
                              <Download className="w-3.5 h-3.5" />
                            )}
                            <span className="font-semibold whitespace-nowrap">
                              {generatingId === item.id ? 'Loading...' : 'View/Download'}
                            </span>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="py-6 text-center text-gray-500">
                        {language === 'marathi' ? 'कोणताही नमुना सापडला नाही.' : 'No forms found.'}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination Controls */}
            {totalPages > 1 && (
              <div className="flex justify-end items-center bg-gray-50 px-4 py-3 border-t border-gray-200">
                <div className="flex space-x-1 shadow-sm">
                  <button
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                    className="bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 px-3 py-1 text-sm rounded-l-sm disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Previous
                  </button>

                  {/* Dynamically generate page numbers */}
                  {[...Array(totalPages)].map((_, i) => (
                    <button
                      key={i + 1}
                      onClick={() => setCurrentPage(i + 1)}
                      className={`${currentPage === i + 1
                        ? 'bg-[#337ab7] text-white border-[#337ab7]'
                        : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                        } border-y border-r px-3 py-1 text-sm`}
                    >
                      {i + 1}
                    </button>
                  ))}

                  <button
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages || totalPages === 0}
                    className="bg-white border-y border-r border-gray-300 text-[#337ab7] hover:bg-gray-50 px-3 py-1 text-sm rounded-r-sm disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}

          </div>
        </div>
      </main>
    </div>
  );
};

export default PdfItarNamune;
